module.exports = __webpack_public_path__ + "static/img/active_06.271a5c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_06.jpg
// module id = BOWP
// module chunks = 0